import React from 'react';
import {
    OmniStyleComponent,
    OmniLoadingIndicatorComponent
} from './omni-components';

export class LoaderComponent extends React.Component {
    defaultState = {
        spinnerCount: 0,
        displayWholePage: false
    }
    constructor(props) {
        super(props);
        this.state = this.defaultState;
    }

    componentWillReceiveProps(props) {
        if (props.displayWholePage) {
            this.setState({ spinnerCount: props.spinnerCount, displayWholePage: props.displayWholePage })
        } else {
            this.setState({ spinnerCount: props.spinnerCount })
        }
    }

    render() {
        const { spinnerCount, displayWholePage } = this.props;

        return (
            <>
                {spinnerCount > 0 ? 
                <div>
                    {displayWholePage ? <div className='overlay-wholepage'></div> : <div className='overlay'></div>}
                    <OmniLoadingIndicatorComponent></OmniLoadingIndicatorComponent>
                </div>
                : ''}
                </>
            )
        }
}